
riot.tag2('dropdown', '<yield></yield>', 'dropdown { display: block; position: relative; }', '', function(opts) {
this.show = false;

this.on('mount', function() {
  return this.root.addEventListener('click', this.toggle);
});

this.on('unmount', function() {
  this.root.removeEventListener('click', this.toggle);
  return document.removeEventListener('click', this.hide);
});

this.hide = (function(_this) {
  return function(e) {
    _this.show = false;
    document.removeEventListener('click', _this.hide);
    _this.root.className = _this.root.className.replace(/ open/, '');
    return _this.update();
  };
})(this);

this.toggle = (function(_this) {
  return function(e) {
    var ref, ref1;
    if ((opts.maxwidth != null) && document.body.offsetWidth > opts.maxwidth) {
      return;
    }
    e.stopPropagation();
    if (((ref = e.target) != null ? (ref1 = ref.attributes) != null ? ref1.target : void 0 : void 0) == null) {
      e.preventDefault();
    }
    _this.show = !_this.show;
    if (_this.show) {
      document.addEventListener('click', _this.hide);
      _this.root.className += " open";
      _this.update();
    } else {
      _this.hide();
    }
    return false;
  };
})(this);
});